const e = "styles-module__scaleInputContainer___76Jc-", l = "styles-module__scaleInput___Soo34", s = "styles-module__scaleInputLabels___TAA6e", t = "styles-module__labelWrapper___Rt0eJ", _ = "styles-module__currentValue___oMX6N", a = "styles-module__label___66Dg9", n = {
  scaleInputContainer: e,
  scaleInput: l,
  scaleInputLabels: s,
  labelWrapper: t,
  currentValue: _,
  label: a
};
export {
  _ as currentValue,
  n as default,
  a as label,
  t as labelWrapper,
  l as scaleInput,
  e as scaleInputContainer,
  s as scaleInputLabels
};
